import { render, staticRenderFns } from "./MenuNotifications.vue?vue&type=template&id=ea3e01be&scoped=true&"
import script from "./MenuNotifications.vue?vue&type=script&lang=js&"
export * from "./MenuNotifications.vue?vue&type=script&lang=js&"
import style0 from "./MenuNotifications.vue?vue&type=style&index=0&id=ea3e01be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea3e01be",
  null
  
)

export default component.exports